module.exports = __webpack_public_path__ + "./img/Autopartes-del-Sur--BlancoNew.53ce2d9e4bef8f8bbe82231b66fb6ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Autopartes-del-Sur--BlancoNew.png
// module id = ./src/assets/img/Autopartes-del-Sur--BlancoNew.png
// module chunks = 6